import CalendarViewMonthIcon from "@mui/icons-material/CalendarViewMonth";
import Spec from "csi/core/Spec";
import { TYPE_IMAGE } from "csi/reflection/reflectionConstants";
import React, { FunctionComponent } from "react";
import { getAttributeIcon } from "./icons";

interface AttributeIconProps {
	/** attribute spec */
	spec: Spec;
}

const AttributeIcon: FunctionComponent<AttributeIconProps> = function AttributeIcon({ spec }) {
	const { format, key, isMatrix, isMatrixGroup, rcDest, type } = spec;
	const targetType = key.isForShowingReferencedImages ? TYPE_IMAGE : rcDest?.type;
	const IconComponent = (isMatrix && !isMatrixGroup) ? CalendarViewMonthIcon : getAttributeIcon(type, format, targetType);

	return (
		<IconComponent />
	);
};

export default AttributeIcon;